import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AllocationGridSlidingPanel from './AllocationGridSlidingPanel';
import { fetchAllocationRules, applyAllocationRuleToLines } from 'redux/rules/RulesActions';

const mapStateToProps = ({ invoices, rules }) => ({
  rules: rules.rules,
  fetchingRules: rules.fetchingRules,
  allocationPageState: rules.pageState,
  applyingAllocationRule: rules.applyingAllocationRule,
  invoiceLinesPageState: invoices.pageStateLines,
});

const mapDispatchToProps = dispatch => ({
  rulesActions: bindActionCreators({ fetchAllocationRules, applyAllocationRuleToLines }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AllocationGridSlidingPanel);



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceLinesGrid/c/allocationGridSlidingPanel/AllocationGridSlidingPanelConnector.js